export default __webpack_public_path__ + "static/logo-footer-9c9d0409b5846e800e02125306a70226.svg";